import * as React from 'react';
import {
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    FormControlLabel,
    IconButton,
    // DialogTitle,
    Slide,
} from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';
import { EditMode } from '../Types';
import { useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import GreenFieldVideo from '../../../Assets/Videos/GreenArea.mp4';

const styles = makeStyles((theme) => ({
    paper: {
        backgroundColor: '#0e0c10ad',
        borderRadius: '5px',
        maxWidth: '400px',
        padding: '16px',
        boxSizing: 'border-box',
    },
    contentText: {
        fontFamily: 'Poppins',
        fontWeight: 400,
        fontSize: '16px',
        lineHeight: '32px',
        letterSpacing: '0.04em',
        color: '#EDE8E8',
        textTransform: 'uppercase' as 'uppercase',
        textAlign: 'center',
        marginBottom: '18px',
    },
    buttonContainer: {
        display: 'block',
        padding: '0px',
    },
    button: {
        color: theme.palette.common.white,
        marginBottom: '10px',
        backgroundColor: theme.palette.primary.main,
        borderRadius: theme.spacing(1),
        width: '28%',
        fontSize: '14px',
        fontFamily: 'Poppins',
        fontWeight: 600,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
    },
    checkboxContaner: {
        alignSelf: 'flex-end',
        margin: '0px',
        padding: '0px',
        color: '#CAC5C5',
        marginTop: '12px',
    },
    cardHeaderCss: {
        display: 'flex',
        justifyContent: 'flex-end',
        cursor: 'pointer',
        marginBottom: '12px',
    },
    actionFooterCss: {
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: '16px',
    },
}));

interface IProps {
    editMode: EditMode;
    open: boolean;
    updateChromKeyDialogStatus: (status: boolean) => void;
}

const Transition = React.forwardRef(
    (
        props: TransitionProps & { children?: React.ReactElement<any, any> },
        ref: React.Ref<unknown>
    ) => <Slide direction='up' ref={ref} {...props} timeout={800} />
);

export function ChromakeyDialog({
    editMode,
    open,
    updateChromKeyDialogStatus,
}: IProps) {
    const videoRef = useRef<HTMLVideoElement>(null);
    console.log(videoRef, 'here ref');
    const classes = styles();
    const doNotShowPrompt =
        localStorage.getItem('doNotShow_chromakey') === 'true';
    console.log(editMode, open, 'hereree');
    useEffect(() => {
        if (!open && editMode !== 'chromakey_first_mount') {
            updateChromKeyDialogStatus(true);
        }
    }, [editMode]);

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.checked) {
            localStorage.setItem('doNotShow_chromakey', 'true');
        } else {
            localStorage.removeItem('doNotShow_chromakey');
        }
    }

    useEffect(() => {
        const videoElement = videoRef.current;
        console.log(videoElement, 'comgin');
        if (videoElement) {
            videoElement.loop = true;
            videoElement.controls = true; // Add controls attribute
            videoElement.play().catch((error) => {
                console.error('Error playing video:', error);
            });
        }
    }, [videoRef]);

    return !doNotShowPrompt ? (
        <Dialog
            open={editMode === 'chromakey_first_mount' && open}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => updateChromKeyDialogStatus(false)}
            aria-labelledby='alert-dialog-slide-title'
            aria-describedby='alert-dialog-slide-description'
            classes={{ paper: classes.paper }}
        >
            <DialogContent style={{ padding: '0px' }}>
                <div className={classes.cardHeaderCss}>
                    <IconButton
                        aria-label='Close modal'
                        component='span'
                        onClick={() => updateChromKeyDialogStatus(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
                <DialogContentText
                    id='alert-dialog-slide-description'
                    className={classes.contentText}
                >
                    Click on the green parts of the field so that the tools work
                </DialogContentText>
                <video
                    src={GreenFieldVideo}
                    height='250'
                    loop
                    muted={true}
                    autoPlay={true}
                />
            </DialogContent>
            <DialogActions className={classes.buttonContainer}>
                <div>
                    <FormControlLabel
                        className={classes.checkboxContaner}
                        control={
                            <Checkbox
                                onChange={handleChange}
                                style={{ color: '#7FF0E3' }}
                            />
                        }
                        label='Don’t show this message again'
                    />
                </div>
                <div className={classes.actionFooterCss}>
                    <Button
                        onClick={() => updateChromKeyDialogStatus(false)}
                        className={classes.button}
                    >
                        Confirm
                    </Button>
                </div>
            </DialogActions>
        </Dialog>
    ) : (
        <></>
    );
}



// WEBPACK FOOTER //
// ./src/Features/TelestrationsVideoLibrary/Components/ChromakeyDialog.tsx